/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { clear } from 'console';
import { CatalogFileCollection } from '../../../common/libraries/fileFormats/catalog/catalog';
import { NavigationReducer } from '../../../Redux/Reducers/NavigationReducer';
import { useAppSelector } from '../../../Redux/Store/hooks';
import { CatalogObjectDisplayObject } from '../../Data/CatalogObjectDisplayObject';
import { HorizontalListComponent } from '../Components/Specific/HorizontalListComponent';
import { SliderComponent } from '../Components/Specific/SliderComponent';
import { POSCatalogData } from '../../../common/libraries/modelViewer/Data/POSCatalogData';
import { CatalogTagsTranslation } from '../../../common/libraries/modelViewer/Data/catalogTagsTranslation';
import ClearCacheIcon from '../../../Resources/Images/clear-cache.svg';

type HomeViewParameters = {
  catalog : POSCatalogData,
  spotlightCollections : CatalogFileCollection[],
  spotlightObjects : Array<CatalogObjectDisplayObject>,
  clearCacheHandler : () => void,
};

export function HomeView({
  catalog, spotlightCollections, spotlightObjects, clearCacheHandler,
}: HomeViewParameters) {

  // const [
  //   spotLightObjectLabelTranslation,
  //   setSpotLightObjectLabelTranslation] = useState<CatalogTagsTranslation | undefined>(undefined);

  // useEffect(() => {
  //   const tagTrans = catalog.catalogFileInfo?.tagsTranslation.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('spotlight-object-label')));
  //   setSpotLightObjectLabelTranslation(tagTrans);
  // }, [catalog]);

  // Grab the dispatch hook from Redux
  const dispatch = useDispatch();

  const lang = useAppSelector((state) => {
    return state.TextsReducer.language;
  });

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  const { changeState } = NavigationReducer.actions;

  const displayNewPage = (collectionName: string, objectName : string, pageType : string) => {
    dispatch(
      changeState({
        page: pageType,
        collection: collectionName,
        object: objectName,
        filter: undefined,
        searchQuery: undefined,
      }),
    );
  };

  // const spotLightObjectLabel = CatalogTagsTranslation.getTranslation(
  //   spotLightObjectLabelTranslation,
  //   lang,
  // ) || strings.SPOTLIGHT_OBJECTS_LABEL || 'something went wrong...';

  return (
    <div style={{ height: '100%', overflowY: 'auto', position: 'relative' }}>
      {/* Top Bar */}
      <div
        style={{
          height: '22px',
          width: '100%',
          backgroundColor: '#ffffff', // you can change this color
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '0 12px',
          boxSizing: 'border-box',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img
          src={ClearCacheIcon}
          alt="Clear Cache"
          style={{
            width: '20px',
            height: '20px',
            cursor: 'pointer',
            opacity: 0.8,
          }}
          onClick={() => {
            console.log('Clear cache clicked');
            clearCacheHandler();
            // you can trigger your clear cache logic here
          }}
        />
      </div>

      {/* Main content */}
      <div className="homepage-white-section">
        <SliderComponent
          spotlight={spotlightCollections}
          displayNewPage={displayNewPage}
        />
      </div>

      <div className="homepage-spotlight-section">
        <HorizontalListComponent
          title={strings.SPOTLIGHT_OBJECTS_LABEL}
          itemList={spotlightObjects}
          displayNewPage={displayNewPage}
          noContentText={strings.NO_CONTENT_TEXT}
        />
      </div>
    </div>
  );
}
